/**
 * Writing a field's name into a formula.
 *
 * The backend unescapes a single-quoted literal with exactly one rule --
 * `\'` becomes `'`, and nothing else is special -- so this is that rule
 * backwards, and it is here rather than beside either of its two callers
 * because there must only ever be one of it.
 */

/** A field name as a formula literal, quoted and escaped. */
export function nameLiteral(name: string): string {
  return `'${name.replace(/'/g, "\\'")}'`
}
